/**
 * bootstrap grid setting
 *
 * row.padding === col.padding === container.padding
 */

export default {
    gridGutterWidth: 10,
    gridColumns: 24,
    gridBreakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1540,
    },
    containerMaxWidths: {
        sm: 540,
        md: 720,
        lg: 960,
        xl: 1140,
        xxl: 1460,
    },
};
